const LOGIN_SESSION_STORAGE_KEY = 'zenid.login-check-web.authenticatedAt';
export const LOGIN_SESSION_TTL_MS = 60 * 60 * 1000;

function getCurrentTimestampMs() {
  return new Date().getTime();
}

export function saveLoginSession(now = getCurrentTimestampMs()) {
  window.sessionStorage.setItem(LOGIN_SESSION_STORAGE_KEY, String(now));
}

export function clearLoginSession() {
  window.sessionStorage.removeItem(LOGIN_SESSION_STORAGE_KEY);
}

export function isLoginSessionValid(now = getCurrentTimestampMs()) {
  const storedAuthenticatedAt = window.sessionStorage.getItem(LOGIN_SESSION_STORAGE_KEY);
  if (!storedAuthenticatedAt) {
    return false;
  }
  const authenticatedAt = Number(storedAuthenticatedAt);
  return Number.isFinite(authenticatedAt) && authenticatedAt <= now && now - authenticatedAt <= LOGIN_SESSION_TTL_MS;
}
